



























import { Component, Vue } from 'vue-property-decorator';
import Img from '@/main-components/common/Img.vue';

@Component({
  components: {
    Img,
  },
})
export default class PaperCreateInfo extends Vue {
  steps = [
    {
      title: 'Bina Latihan',
    },
    {
      title: 'Tambah soalan ke dalam latihan',
    },
    {
      title: 'Jana PDF atau kongsi latihan anda melalui pautan',
    },
  ];
}
